import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import {buttonType} from '../../utils/commonPropTypes'
import WidthContainer from '../WidthContainer'
import List from '../List'
import {QueryedButton} from '../Button'
import StarsContainer from '../Stars'
import LatestMeetups from '../LatestMeetups'
import WavyBackground from '../WavyBackground'

const phoneBreakpoint = '@media only screen and (max-width: 1000px)'

const RootContainer = styled(WavyBackground)`
`
RootContainer.defaultProps = {
	type: 'gray',
}

const Stars = styled(StarsContainer)`
	position: absolute;
	top: 0;
	margin: 0 auto;
	z-index: 1;
`
Stars.defaultProps = {
	width: '60rem',
}

const InnerContainer = styled(WidthContainer)`
	display: flex;
	padding-top: 5.25rem;
	padding-bottom: 2.31rem;
	margin-top: -3rem;
	margin-bottom: -3rem;
	
	${phoneBreakpoint} {
		flex-direction: column-reverse;
		align-items: center;
		margin-top: -5rem;s
	}
`
const Column = styled.div`
	flex: 1;
	margin: 3rem 0;
`

const InnerRight = styled.div`
	max-width: 27rem;
	position: relative;
	z-index: 2;
`

const Title = styled.h1`
	margin-bottom: 2.5rem;
	
	@media only screen and (max-width: 700px) {
		font-size: ${props => props.theme.fontSizes.big30};
	}
`

const Points = styled(List)`
`
Points.defaultProps = {
	spaces: 'smaller',
}

const Text = styled.div`
	margin: 2.5rem 0 1.25rem;
	font-size: ${props => props.theme.fontSizes.small};
`

const Button = styled(QueryedButton)`
`
Button.defaultProps = {
	inverted: true,
}

const LatestMeetupsStyled = styled(LatestMeetups)`
	// Make sure the stars are displayed over the blobs but not over theirs content.
	& > * > * > * {
		position: relative;
		z-index: 2;
	}
`

const EventSection = ({data, className}) => <RootContainer className={className}>
	<Stars/>
	<InnerContainer>
		<Column>
			<LatestMeetupsStyled/>
		</Column>
		<Column>
			<InnerRight>
				<Title>{data.title}</Title>
				<Points items={data.bullets.map(one => one.text)}/>
				<Text>{data.text}</Text>
				<Button data={data.button}/>
			</InnerRight>
		</Column>
	</InnerContainer>
</RootContainer>

EventSection.propTypes = {
	className: PropTypes.string,
	data: PropTypes.shape({
		title: PropTypes.string.isRequired,
		bullets: PropTypes.arrayOf(PropTypes.shape({
			text: PropTypes.string.isRequired,
		}).isRequired).isRequired,
		text: PropTypes.string.isRequired,
		button: buttonType.isRequired,
	}).isRequired,
}

EventSection.defaultProps = {
	className: '',
}

export default EventSection
